import { FieldDefinition } from "./fieldDefinitions";
import { RvStatus, RvStatusLabels } from "../constants";

export interface RvDto {
  rvId: number;
  patientId: number;
  patientLastName: string;
  patientFirstName: string;
  doctorId: number;
  doctorLastName: string;
  doctorFirstName: string;
  rvReason?: string;
  day: string; // "YYYY-MM-DD"
  startTime: string; // "HH:mm"
  endTime: string; // "HH:mm"
  status: number;
  active: boolean;
}

export const rvKeyId = "rvId" as const;

// Ορίζουμε τον τύπο των πεδίων για τη φόρμα
export const rvFields: FieldDefinition[] = [
  {
    name: "patientId",
    label: "Ασθενής",
    type: "number",
    required: true,
  },
  {
    name: "doctorId",
    label: "Γιατρός",
    type: "number",
    required: true,
  },
  {
    name: "rvReason",
    label: "Λόγος Ραντεβού",
    type: "text",
    required: false,
  },
  {
    name: "day",
    label: "Ημερομηνία",
    type: "date",
    required: true,
  },
  {
    name: "startTime",
    label: "Ώρα Έναρξης",
    type: "time",
    required: true,
  },
  {
    name: "endTime",
    label: "Ώρα Λήξης",
    type: "time",
    required: true,
  },
  {
    name: "status",
    label: "Κατάσταση",
    type: "select",
    required: true,
    options: [
      { label: RvStatusLabels[RvStatus.SCHEDULED], value: RvStatus.SCHEDULED },
      { label: RvStatusLabels[RvStatus.CANCELLED], value: RvStatus.CANCELLED },
      { label: RvStatusLabels[RvStatus.COMPLETED], value: RvStatus.COMPLETED },
    ],
  },
] as const;

export const rvFilters = rvFields.filter((f) =>
  ["patientId", "doctorId", "day", "status"].includes(f.name),
);

export const rvFormData: FieldDefinition[] = [
  {
    name: "patientLastName",
    label: "Επώνυμο Ασθενή",
    type: "text",
    required: true,
  },
  {
    name: "patientFirstName",
    label: "Όνομα Ασθενή",
    type: "text",
    required: true,
  },
  {
    name: "doctorLastName",
    label: "Επώνυμο Γιατρού",
    type: "text",
    required: true,
  },
  {
    name: "doctorFirstName",
    label: "Όνομα Γιατρού",
    type: "text",
    required: true,
  },
  {
    name: "rvReason",
    label: "Λόγος Ραντεβού",
    type: "text",
    required: false,
  },
  {
    name: "day",
    label: "Ημερομηνία",
    type: "date",
    required: true,
  },
  {
    name: "startTime",
    label: "Ώρα Έναρξης",
    type: "time",
    required: true,
  },
  {
    name: "endTime",
    label: "Ώρα Λήξης",
    type: "time",
    required: true,
  },
  {
    name: "status",
    label: "Κατάσταση",
    type: "text",
    required: true,
  },
] as const;

export interface SearchFilterState {
  firstName: string;
  lastName: string;
  amka: string;
}
